import React, { useMemo } from 'react';
import { api } from '../../services/api';
import { FIELD_LABELS } from '../../utils/fieldLabels';
import { parseVendorsResponse } from '../../utils/stringComboboxUtils';
import StringCombobox from '../StringCombobox/StringCombobox';

interface VendorComboboxProps {
  value: string;
  onChange: (vendor: string) => void;
  invalid?: boolean;
  vendorNameInputClassName?: string;
  vendorArrowClassName?: string;
  disabled?: boolean;
}

const VendorCombobox: React.FC<VendorComboboxProps> = ({
  value,
  onChange,
  invalid = false,
  vendorNameInputClassName = '',
  vendorArrowClassName = '',
  disabled = false,
}) => {
  const config = useMemo(
    () => ({
      removedStorageKey: 'removedSuppliers',
      fetchItems: api.expenses.getVendors,
      parseItems: parseVendorsResponse,
      logLabel: 'vendors',
    }),
    []
  );

  const labels = useMemo(
    () => ({
      fieldLabel: FIELD_LABELS.vendorName,
      openListAriaLabel: 'פתח רשימת ספקים',
      searchAriaLabel: 'חפש ספק',
      emptyText: 'לא נמצאו ספקים',
      noResultsText: 'אין תוצאות',
      removeItemTitle: 'הסר מהרשימה',
      optionIdPrefix: 'vendor-option',
    }),
    []
  );

  return (
    <StringCombobox
      value={value}
      onChange={onChange}
      config={config}
      labels={labels}
      invalid={invalid}
      nameInputClassName={vendorNameInputClassName}
      arrowClassName={vendorArrowClassName}
      disabled={disabled}
    />
  );
};

export default VendorCombobox;
